/* eslint-disable react/no-danger */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-shadow */
import React, { createRef, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import classNames from 'classnames';

import ModalViewImages from '../ModalViewImages';
import { Typping } from './Typping';
import { CollectAcceptType } from '../../../util/collect-accept-type';
import Carousel from '../../Carousel';
import DocumentMessage from '../../DocumentMessage';
import SuggestionList from '../../SuggestionList';
import QuickAccess from '../../QuickAccess';

const MenuBlock = ({ message }) => (
  <p className="chat-box__body--message">
    {message.message.body}
    <br />
    {message.message.state.menuItems.map((value, index) => {
      const { description } = value;
      return (
        <Fragment key={String(index)}>
          {index + 1} - {description}
          <br />
        </Fragment>
      );
    })}
  </p>
);

const BotMessage = (props) => {
  const { message, handleCarouselButtonClick } = props;
  const { i18n } = useTranslation();
  const collectAcceptTypes = (item) => {
    let acceptTypes = '';
    if (item.acceptFiles.includes(CollectAcceptType.Image)) {
      acceptTypes = 'image/*';
    }
    if (item.acceptFiles.includes(CollectAcceptType.Document)) {
      acceptTypes += acceptTypes.length > 0 ? ',' : '';
      acceptTypes += 'application/pdf';
    }
    if (item.acceptFiles.includes(CollectAcceptType.Video)) {
      acceptTypes += acceptTypes.length > 0 ? ',' : '';
      acceptTypes += 'video/*';
    }
    if (item.acceptFiles.includes(CollectAcceptType.Audio)) {
      acceptTypes += acceptTypes.length > 0 ? ',' : '';
      acceptTypes += 'audio/*';
    }
    return acceptTypes;
  };

  const [collectFile, setCollectFile] = useState(undefined);
  const [collectFileSent, setCollectFileSent] = useState(false);

  const collectFileSelected = (message, e) => {
    const file = e.target.files ? e.target.files[0] : undefined;
    setCollectFile(file);
    setCollectFileSent(false);
    setTimeout(() => {
      setCollectFileSent(true);
    }, 2000);

    const { sendUserFileMessage } = props;

    if (file) {
      sendUserFileMessage('USER', file, { when: new Date(), body: '' });
    }
  };

  const treatMessage = (message) => {
    const linkRegex =
      /((http:\/\/|https:\/\/|ftp:\/\/)|(www.))+([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/gi;
    const strongRegex = /\*(.*?)\*/g;
    const breaklineRegex = /\n/g;

    let messageTreated = message.replace(linkRegex, function (str) {
      if (!str.match(/http/)) {
        return `<a target="_blank" href="http://${str}">${str}</a>`;
      }
      return `<a target="_blank" href="${str}">${str}</a>`;
    });

    messageTreated = messageTreated.replace(strongRegex, function (str) {
      return `<strong>${str.substr(1, str.length - 2)}</strong>`;
    });

    messageTreated = messageTreated.replace(breaklineRegex, '<br/>');

    let validationMessageHTML = false;

    const validatedTag = ['<html', '<script', '<style', '<table'];

    validationMessageHTML = validatedTag.some((tag) =>
      messageTreated.includes(tag)
    );

    let createReturnHTML = '';

    if (messageTreated.includes('<finaltag />')) {
      createReturnHTML = `<xmp style="white-space: break-spaces;">${
        messageTreated.split('<finaltag />')[0]
      }</xmp>`;

      createReturnHTML += messageTreated.split('<finaltag />')[1];
    }

    return validationMessageHTML ? createReturnHTML : messageTreated;
  };

  return (
    <Fragment>
      <div className="container-chat-box align-self-start">
        {(message && message.type === 'CAROUSEL' && (
          <div style={{ width: '210px', position: 'relative' }}>
            <Carousel
              carouselData={message.carousel}
              onButtonClick={(buttonInfo) =>
                handleCarouselButtonClick(buttonInfo)
              }
            />
          </div>
        )) ||
          (message && message.type === 'DOCUMENT' && (
            <DocumentMessage
              divId={message.from === 'BOT' ? 'botMessage' : 'userMessage'}
              message={message}
            />
          )) || (
            <div className="chat-box__body--bot ml-auto m-1">
              <p
                className="chat-box__body--message"
                style={{
                  borderRadius: '10px 10px 10px 0px ',
                  overflow: 'hidden',
                }}
              >
                {message.type === 'TYPING' && <Typping />}

                {message.type === 'MESSAGE' && (
                  <p
                    className="chat-box__body--message"
                    dangerouslySetInnerHTML={{
                      __html: treatMessage(message.message),
                    }}
                  />
                )}

                {message.type === 'TEXT' && (
                  <p
                    className="chat-box__body--message"
                    dangerouslySetInnerHTML={{
                      __html: treatMessage(message.message),
                    }}
                  />
                )}

                {message &&
                  message.type !== 'TYPING' &&
                  message.type === 'Text' && (
                    <p className="chat-box__body--message">{message.message}</p>
                  )}

                {message && message.type === 'Menu' && (
                  <MenuBlock message={message} />
                )}

                {message && message.type === 'VIDEO' && (
                  <video
                    preload="auto"
                    controls
                    className="img-fluid"
                    style={{ marginBottom: -5 }}
                  >
                    <track kind="captions" />
                    <source src={message.video.fileUrl} type="video/mp4" />
                  </video>
                )}

                {message && message.type === 'AUDIO' && (
                  <audio preload="auto" controls className="preview-audio">
                    <track kind="captions" />
                    <source src={message.audio.fileUrl} type="audio/mp3" />
                  </audio>
                )}

                {message && message.type === 'IMAGE' && (
                  <img
                    srcSet={message.image}
                    className={classNames({
                      'img-fluid': true,
                    })}
                    style={{
                      borderRadius: '10px 10px 10px 0',
                      cursor: 'pointer',
                    }}
                    alt={message?.fileDescription || ''}
                    onClick={() => {
                      props.handleToggleModal(message);
                    }}
                  />
                )}

                {message && message.type === 'Collect' && (
                  <div className="chat-box__body--collect">
                    {!collectFile && (
                      <input
                        id={`${message.message.state._id}-file`}
                        name={`${message.message.state._id}-file`}
                        type="file"
                        accept={collectAcceptTypes(message.message.state)}
                        onChange={(e) =>
                          collectFileSelected(message.message, e)
                        }
                      />
                    )}
                    {!collectFile && (
                      <label htmlFor={`${message.message.state._id}-file`}>
                        {i18n.t('Selecione um arquivo')}
                      </label>
                    )}
                    {collectFile && !collectFileSent && (
                      <span>Enviando 100%</span>
                    )}
                    {collectFile && collectFileSent && (
                      <p className="chat-box__body--message">
                        {collectFile.name}
                      </p>
                    )}
                  </div>
                )}
              </p>
            </div>
          )}
      </div>
    </Fragment>
  );
};

const UserMessage = (props) => {
  const { message } = props;
  if (message && message.type === 'DOCUMENT') {
    return (
      <div className="flex-row">
        <DocumentMessage
          divId={message.from === 'BOT' ? 'botMessage' : 'userMessage'}
          message={message}
          channel="preview"
          color="#F49400"
        />
      </div>
    );
  }
  return (
    <div className="flex-row">
      <div className="chat-box__body--user ml-auto m-1">
        <p
          className="chat-box__body--message"
          style={{
            borderRadius: '10px 10px 0px 10px',
            overflow: 'hidden',
          }}
        >
          {message && message.type === 'TEXT' && message.message}
          {message && message.type === 'IMAGE' && (
            <img
              src={message.message}
              className={classNames({ 'img-fluid': true })}
              alt=""
              onClick={() => props.handleToggleModal(message)}
              style={{ cursor: 'pointer' }}
            />
          )}

          {message && message.type === 'VIDEO' && (
            <video
              preload="auto"
              controls
              className="img-fluid"
              style={{ marginBottom: -5 }}
            >
              <track kind="captions" />
              <source src={message.message} type="video/mp4" />
            </video>
          )}

          {message && message.type === 'AUDIO' && (
            <audio preload="auto" controls className="preview-audio">
              <track kind="captions" />
              <source src={message.message} type="audio/mp3" />
            </audio>
          )}
        </p>
      </div>
    </div>
  );
};

const MessageList = (props) => {
  const { messages, handleCarouselButtonClick, handleToggleModal } = props;

  return messages.map((message, index) => {
    if (message.from === 'USER') {
      return (
        <UserMessage
          message={message}
          {...props}
          key={String(index)}
          handleToggleModal={handleToggleModal}
        />
      );
    }
    return (
      <BotMessage
        handleCarouselButtonClick={handleCarouselButtonClick}
        message={message}
        {...props}
        key={String(index)}
        handleToggleModal={handleToggleModal}
      />
    );
  });
};

class ChatBody extends React.Component {
  listRef = createRef();

  state = {
    messageSelected: {},
  };

  startTest = (event) => {
    event.preventDefault();
    const { startTest } = this.props;
    startTest([]);
  };

  handleToggleModal = (message) => {
    this.setState({
      messageSelected:
        Object.values(this.state.messageSelected).length === 0 ? message : {},
    });
  };

  render() {
    const { firstTest, handleCarouselButtonClick } = this.props;
    const { messages } = this.props;
    const lastMessage = messages[messages.length - 1];

    let open = false;

    if (lastMessage && lastMessage.suggestionList) {
      open = true;
    }

    if (firstTest) {
      return (
        <section className="chat-box__body d-flex flex-column align-items-center justify-content-center">
          <img src="/assets/images/icon-new-bot.svg" alt="Happy robbot" />
          <span className="chat-box__body--welcome">
            Seu bot está preparado para ser testado
          </span>
          <button
            type="button"
            className="chat-box__body--button"
            onClick={this.startTest}
          >
            Iniciar teste
          </button>
        </section>
      );
    }

    return (
      <Fragment>
        <section
          className="chat-box__body d-flex flex-column align-items-end"
          ref={this.listRef}
        >
          <MessageList
            handleCarouselButtonClick={handleCarouselButtonClick}
            {...this.props}
            handleToggleModal={this.handleToggleModal}
          />
          <QuickAccess
            channel="preview"
            isQuickAccessOpen={this.props.isQuickAccessOpen}
            quickAccess={this.props.quickAccess}
            handleSendId={this.props.handleSendId}
            handleCloseQuickAccess={this.props.handleCloseQuickAccess}
          />
        </section>
        {open ? (
          <SuggestionList
            list={lastMessage.suggestionList}
            sendMessage={this.props.sendMessage}
          />
        ) : (
          ''
        )}

        <ModalViewImages
          message={this.state.messageSelected}
          onClose={this.handleToggleModal}
        />
      </Fragment>
    );
  }

  componentDidUpdate() {
    const that = this;
    setTimeout(function () {
      try {
        that.listRef.current.scrollTop =
          that.listRef.current.scrollHeight - that.listRef.current.clientHeight;
      } catch (e) {
        console.log('Test is closed');
      }
    }, 50);
  }
}

export default ChatBody;
